import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useGoogleTagManager } from '../../hooks/useGoogleTagManager';
import { useTracking } from '../../hooks/useTracking';
import { LOCAL_STORAGE_USER_INFO_KEY } from '../../constants/misc';
import {
  TRACKING_DOWNLOAD_APP_PAGE,
  TRACKING_PURCHASE,
  TRACKING_PURCHASE_LOCAL_STORAGE_KEY,
} from '../OnboardingForm/constants';
import { useThankYouPage } from './useThankYouPage';
import ThankYouAppointmentBooked from 'components/ThankYouView/ThankYouAppointmentBooked';
import ThankYouNoAppointment from 'components/ThankYouView/ThankYouNoAppointment';
import { StickyCtaLayout } from 'components/ui/StickyCtaLayout';
import { Link, Text, VStack } from 'components/ui';
import HeaderNav from 'components/HeaderNav/HeaderNav';
import ThankYouHeading from 'components/ThankYouView/ThankYouHeading';
import { LoadingScreen } from '../ui/LoadingScreen';

const ThankYou = () => {
  const { trackEventInGoogleTagManager } = useGoogleTagManager();
  const { page: pageView } = useTracking();
  const {
    redirectToHome,
    timezone,
    bookedMeeting,
    userEmail,
    isCollaborative,
    isLoading,
    hasOccurredMeeting,
  } = useThankYouPage();

  const trackPurchaseComplete = !!localStorage.getItem(
    TRACKING_PURCHASE_LOCAL_STORAGE_KEY
  );

  useEffect(() => {
    pageView(TRACKING_DOWNLOAD_APP_PAGE);

    if (trackPurchaseComplete) {
      trackEventInGoogleTagManager(TRACKING_PURCHASE);
      localStorage.removeItem(TRACKING_PURCHASE_LOCAL_STORAGE_KEY);
      localStorage.removeItem(LOCAL_STORAGE_USER_INFO_KEY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (redirectToHome) return <Navigate to={'/'} replace />;

  if (isLoading) return <LoadingScreen />;

  return (
    <StickyCtaLayout header={<HeaderNav />} maxWidth="formWidth">
      <VStack alignItems={'center'} gap={4} w="100%">
        <ThankYouHeading hasBookedMeeting={!!bookedMeeting} />
        {bookedMeeting ? (
          <ThankYouAppointmentBooked
            bookedMeeting={bookedMeeting}
            timezone={timezone}
            email={userEmail}
          />
        ) : (
          <ThankYouNoAppointment
            email={userEmail}
            isCollaborative={isCollaborative}
            hasOccurredMeeting={hasOccurredMeeting}
          />
        )}

        <Text
          color="blueGray.600"
          fontSize="12.5px"
          fontWeight="normal"
          lineHeight="1.55"
          maxW="340px"
          mt={4}
          textAlign="center"
        >
          Need help? Reach our team at
          <br />
          <Link
            color="aqua.500"
            fontWeight={600}
            href="mailto:support@ayblehealth.com"
            textDecoration="none"
            _hover={{ textDecoration: 'underline' }}
          >
            support@ayblehealth.com
          </Link>{' '}
          or call us at{' '}
          <Link
            color="aqua.500"
            fontWeight={600}
            href="tel:8574169299"
            textDecoration="none"
            _hover={{ textDecoration: 'underline' }}
          >
            (857) 416-9299
          </Link>
        </Text>
      </VStack>
    </StickyCtaLayout>
  );
};

export default ThankYou;
